export var enums: any = {}
export enum PaymentStatus {
    Notpayed = 0,
    PaymentInProgress = 1,
    PaymentComplete = 2,
    Returned = 3
}
export enum BrokerType {
    ECB = 1,
    Vendor = 2
}
export enum DeliveryStatus {
    NotProcessed = 0,
    Waiting = 1,
    Approved = 2,
    PackAndShipping = 3,
    Returned = 4,
    Delivered = 5,
    Canceled = 6
}
export enum DiscountType {
    Normal = 1,
    Coupon = 2
}
export enum PaymentMethod {
    vPos = 1,
    COD = 2,
    Cart = 3,
    BankTransfer = 4,
}
enums.PaymentStatus = PaymentStatus;
enums.BrokerType = BrokerType;
enums.DeliveryStatus = DeliveryStatus;
enums.DiscountType = DiscountType;
enums.PaymentMethod = PaymentMethod;


// WEBPACK FOOTER //
// ./src/store-modules/app/value/enums.ts